import { useUserStore } from '../../../Stores/UserStore/UserStore'
import drawerStates from '../../CustomerProjectDrawer/Constants/drawerStates'

import React, { useContext } from 'react'

import { useVehicleStore } from 'Stores/VehicleStore'
import ClassNames from 'classnames'

import { addToGarage, showAddToGarage } from 'Utilities/CustomerProjectUtilities/customerProjectUtilities'
import getFitmentDetailsFromSelectedFacets from 'Utilities/CustomerProjectUtilities/getFitmentDetailsFromSelectedFacets'
import getMatchingProject from 'Utilities/CustomerProjectUtilities/getMatchingProject'

import { NavigationContext } from 'Contexts/Navigation/NavigationContext'
import { NotificationContext } from 'Contexts/NotificationContext/NotificationContext'
import { useSkuBaseFitmentData } from 'Contexts/UserSpecificProductDataStore/UserSpecificProductDataStore'

import Panel from 'Atoms/Panel'
import Svg from 'Atoms/Svg'
import Typography from 'Atoms/Typography'

const Fitment = ({
  skuBaseNumber,
  fitmentTargetLabel: fitmentTargetLabel,
  styles,
  index,
  page,
  fitmentData: fitmentData,
  fitmentSectionInteractive,
  selectedFacetOptions,
}) => {
  const isBot = useUserStore((x) => x.context.isBot)
  let fitment = useSkuBaseFitmentData(skuBaseNumber)

  if (isBot()) {
    fitment = fitmentData
  }

  const { dispatch: navigationDispatch } = useContext(NavigationContext)
  const customerProjects = useVehicleStore((x) => x.context.customerProjects)
  const selectedCustomerProjectState = useVehicleStore((x) => x.context.selectedCustomerProject)
  const vehicleName = fitmentTargetLabel || ''
  const selectedFacets = selectedFacetOptions || []
  const fitmentDetails = getFitmentDetailsFromSelectedFacets(selectedFacets) || {}

  const selectCustomerProject = useVehicleStore((x) => x.selectCustomerProject)
  const addCustomerProject = useVehicleStore((x) => x.addCustomerProject)
  const { PushNotification } = useContext(NotificationContext)

  const canAdd = showAddToGarage(customerProjects, fitmentDetails)

  const handleFacetToGarageSelection = async () => {
    let selectedCustomerProjectId = selectedCustomerProjectState.projectId
    let selectedCustomerProject = customerProjects?.find(
      (customerVehicle) => customerVehicle.projectId === selectedCustomerProjectId,
    )

    if (canAdd) {
      await addToGarage(
        fitmentDetails,
        () => {},
        selectCustomerProject,
        addCustomerProject,
        PushNotification,
        vehicleName,
      )
    } else {
      selectedCustomerProject = getMatchingProject(fitmentDetails, customerProjects)
      if (selectedCustomerProject) {
        selectedCustomerProjectId = selectedCustomerProject?.projectId
        selectCustomerProject(selectedCustomerProject?.projectId)
      }
    }
  }

  try {
    if (typeof window !== 'undefined' && window?.isYmmPage && fitment?.isUniversalFit && index == 1 && page == 'prp') {
      // temporary logging - this component shouldn't really care about it's position and the page it's on
      console.log('Universal part in first position')
    }
  } catch (err) {
    console.log(err)
  }

  const TextDisplay = ({ children, size, font, tone, className }) => {
    if (isBot()) {
      return <h4 className={className}>{children}</h4>
    } else {
      return (
        <Typography size={size} font={font} tone={tone} className={className}>
          {children}
        </Typography>
      )
    }
  }

  const renderFitmentContent = () => {
    if (!fitment) return null

    if (fitment.isDirectFit || fitment.isDrivelineFit) {
      return (
        <div data-testid={'productCardFitment_' + skuBaseNumber} className={styles.fitment}>
          {fitmentTargetLabel ? (
            <>
              <Svg className={styles.fitmentIcon} icon={'check'} intent={'positive'} size={0.875} />
              {isBot() ? (
                <TextDisplay className={styles.fitmentText}>Guaranteed to fit your: {fitmentTargetLabel}</TextDisplay>
              ) : (
                <>
                  <TextDisplay size={0.875} className={styles.fitmentText}>
                    Guaranteed to fit your:
                  </TextDisplay>
                  <TextDisplay size={0.875} font={'bold'}>
                    {fitmentTargetLabel}
                  </TextDisplay>
                </>
              )}
            </>
          ) : (
            <>
              <Svg className={styles.fitmentIcon} icon={'check'} intent={'positive'} size={0.875} />
              <TextDisplay className={styles.fitmentText} size={0.875}>
                Guaranteed To Fit
              </TextDisplay>
            </>
          )}
        </div>
      )
    } else if (fitment.isUniversalFit) {
      return (
        <div data-testid={'productCardFitment_' + skuBaseNumber} className={styles.fitment}>
          <Panel intent={'action'} className={ClassNames(styles.universalFitIcon, styles.fitmentIcon)}>
            <Svg icon={'minus'} size={0.75} />
          </Panel>
          <TextDisplay className={styles.fitmentText} size={0.875}>
            Universal Fit
          </TextDisplay>
          {isBot() ? null : (
            <TextDisplay size={0.75} tone={'subtle'}>
              Modification may be required
            </TextDisplay>
          )}
          {isBot() && <TextDisplay>- Modification may be required</TextDisplay>}
        </div>
      )
    } else if (!fitment.isDirectFit && fitment.additionalEngineLevelFacets?.displayName != null) {
      return (
        <div
          data-testid={'productCardFitment_' + skuBaseNumber}
          className={styles.fitment}
          onClick={(e) => {
            if (fitmentSectionInteractive) {
              e.preventDefault()
              e.stopPropagation()
              navigationDispatch({
                type: 'setAdditionalFacetDrawerState',
                payload: {
                  garageState: {
                    isAdditionalFacetDrawerOpen: true,
                    skuBaseOverride: skuBaseNumber,
                  },
                },
              })
            }
          }}
        >
          <Panel intent={'warning'} className={ClassNames(styles.universalFitIcon, styles.fitmentIcon)}>
            <Svg icon={'warning'} size={0.75} />
          </Panel>
          <TextDisplay className={styles.fitmentText} size={0.875}>
            This Part Might Fit
          </TextDisplay>
          {isBot() ? null : (
            <TextDisplay size={0.75} tone={'subtle'}>
              Select {fitment.additionalEngineLevelFacets?.displayName}
            </TextDisplay>
          )}
          {isBot() && <TextDisplay>- Select {fitment.additionalEngineLevelFacets?.displayName}</TextDisplay>}
        </div>
      )
    } else if (!fitment.isDirectFit && fitment.additionalEngineLevelFacets === null && fitment.promptUserFor) {
      return (
        <div
          data-testid={'productCardFitment_' + skuBaseNumber}
          className={styles.fitment}
          onClick={async (e) => {
            if (fitmentSectionInteractive) {
              e.preventDefault()
              e.stopPropagation()

              let drawerView = drawerStates.updateProjectAddYMM
              if (fitment.promptUserFor === 'RaceType') {
                drawerView = drawerStates.updateProjectAddRaceType
              } else if (fitment.promptUserFor === 'Engine') {
                drawerView = drawerStates.updateProjectAddEngine
              }

              await handleFacetToGarageSelection()

              navigationDispatch({
                type: 'setCustomerProjectDrawerState',
                payload: {
                  garageState: {
                    isCustomerProjectDrawerOpen: true,
                    customerProjectDrawerView: drawerView,
                  },
                },
              })
            }
          }}
        >
          <Panel intent={'warning'} className={ClassNames(styles.universalFitIcon, styles.fitmentIcon)}>
            <Svg icon={'warning'} size={0.75} />
          </Panel>
          <TextDisplay className={styles.fitmentText} size={0.875}>
            This Part Might Fit
          </TextDisplay>
          {isBot() ? null : (
            <TextDisplay size={0.75} tone={'subtle'}>
              Add {fitment.promptUserFor}
            </TextDisplay>
          )}
          {isBot() && <TextDisplay>- Add {fitment.promptUserFor}</TextDisplay>}
        </div>
      )
    } else if (!fitment.isDirectFit && !fitment.unverifiedEngineUsed && fitment.additionalEngineLevelFacets === null) {
      return (
        <div data-testid={'productCardFitment_' + skuBaseNumber} className={styles.fitment}>
          <Panel intent={'negative'} className={ClassNames(styles.universalFitIcon, styles.fitmentIcon)}>
            <Svg icon={'warning'} size={0.75} />
          </Panel>
          <TextDisplay className={styles.fitmentText} size={0.875}>
            This Part May Not Fit
          </TextDisplay>
        </div>
      )
    }

    return null
  }

  return <div className={styles.outerFitment}>{fitment && renderFitmentContent()}</div>
}

export default Fitment
